'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _loading = require('@jg/styles/src/assets/icons/loading.svg');

var _loading2 = _interopRequireDefault(_loading);

var _ = require('..');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sizes = ['small', 'medium', 'large'];

var colours = ['purple', 'white', 'grey', 'blue'];

var propTypes = {
  size: _propTypes2.default.oneOf(sizes),
  colour: _propTypes2.default.oneOf(colours),
  className: _propTypes2.default.string
};

var defaultProps = {
  size: 'medium',
  colour: 'purple',
  className: ''
};

var Loading = function Loading(_ref) {
  var size = _ref.size,
      colour = _ref.colour,
      className = _ref.className;

  var loadingClasses = 'jg-loading--' + size + ' jg-loading--' + colour;
  var classes = className ? [className, loadingClasses].join(' ') : loadingClasses;

  return _react2.default.createElement(_.Svg, { className: classes, markup: _loading2.default });
};

Loading.propTypes = propTypes;

Loading.defaultProps = defaultProps;

exports.default = Loading;


// WEBPACK FOOTER //
// ../~/@jg/components/es/Loading/Loading.js